import { Check } from 'lucide-react';

const plans = [
  {
    name: 'Essencial',
    price: '49',
    period: '/mês',
    desc: 'Perfeito para começar a tua jornada de bem-estar.',
    features: [
      '4 aulas de yoga por mês',
      'Acesso à biblioteca de meditações',
      'Newsletter mensal de bem-estar',
      'Desconto de 10% em workshops',
    ],
    cta: 'Começar',
    featured: false,
  },
  {
    name: 'Premium',
    price: '89',
    period: '/mês',
    desc: 'A escolha mais popular para uma prática consistente.',
    features: [
      'Aulas ilimitadas de yoga e meditação',
      '1 massagem terapêutica por mês',
      'Consulta nutricional trimestral',
      'Acesso a todos os workshops',
      'App exclusiva AURA',
      'Comunidade privada',
    ],
    cta: 'Escolher Premium',
    featured: true,
  },
  {
    name: 'Anual',
    price: '599',
    period: '/ano',
    desc: 'Comprometimento total com o teu bem-estar. Poupa €469.',
    features: [
      'Tudo do plano Premium',
      '12 massagens terapêuticas',
      '4 consultas de nutrição',
      'Retiro anual incluído',
      'Acesso prioritário a aulas',
      'Sessão de coaching mensal',
    ],
    cta: 'Comprometer-me',
    featured: false,
  },
];

export default function Pricing() {
  return (
    <section id="precos" className="relative py-28 overflow-hidden">
      {/* Animated wave background */}
      <div className="pricing-wave-bg">
        <div className="absolute inset-0 bg-gradient-to-br from-sage/8 via-cream to-beige-light/40" />
        <svg
          className="wave-1 absolute bottom-0 left-0 w-full opacity-20"
          viewBox="0 0 1440 320"
          preserveAspectRatio="none"
        >
          <path fill="#7A9E7E" d="M0,160L48,165.3C96,171,192,181,288,165.3C384,149,480,107,576,106.7C672,107,768,149,864,160C960,171,1056,149,1152,138.7C1248,128,1344,128,1392,128L1440,128L1440,320L1392,320L1344,320L1248,320L1152,320L1056,320L960,320L864,320L768,320L672,320L576,320L480,320L384,320L288,320L192,320L96,320L48,320L0,320Z" />
        </svg>
        <svg
          className="wave-2 absolute bottom-0 left-0 w-full opacity-10"
          viewBox="0 0 1440 320"
          preserveAspectRatio="none"
        >
          <path fill="#D4C5A9" d="M0,224L60,213.3C120,203,240,181,360,186.7C480,192,600,224,720,218.7C840,213,960,171,1080,160C1200,149,1320,171,1380,181.3L1440,192L1440,320L1380,320L1320,320L1200,320L1080,320L960,320L840,320L720,320L600,320L480,320L360,320L240,320L120,320L60,320L0,320Z" />
        </svg>
        <svg
          className="wave-3 absolute bottom-0 left-0 w-full opacity-10"
          viewBox="0 0 1440 320"
          preserveAspectRatio="none"
        >
          <path fill="#E8C4B8" d="M0,288L80,277.3C160,267,320,245,480,245.3C640,245,800,267,960,261.3C1120,256,1280,224,1360,208L1440,192L1440,320L1360,320L1280,320L1120,320L960,320L800,320L640,320L480,320L320,320L160,320L80,320L0,320Z" />
        </svg>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6">
        <div className="text-center mb-20 reveal">
          <p className="font-dm text-xs tracking-[0.4em] text-sage uppercase mb-4">Investe em ti</p>
          <h2 className="font-playfair italic text-5xl font-light text-ink">Planos & Preços</h2>
          <div className="w-12 h-px bg-sage mx-auto mt-6" />
          <p className="font-dm text-base text-ink-light mt-6 max-w-sm mx-auto">
            Sem compromissos escondidos. Cancela quando quiseres.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
          {plans.map((plan, i) => (
            <div
              key={plan.name}
              className={`reveal rounded-3xl p-8 relative overflow-hidden cursor-pointer transition-all duration-400 hover:-translate-y-2 ${
                plan.featured
                  ? 'bg-sage text-white shadow-2xl shadow-sage/30 scale-105 md:scale-110'
                  : 'bg-white/80 border border-beige/40 shadow-sm hover:shadow-lg'
              }`}
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              {plan.featured && (
                <div className="absolute top-4 right-4">
                  <span className="font-dm text-[10px] tracking-widest uppercase bg-white/20 text-white px-3 py-1 rounded-full">
                    Popular
                  </span>
                </div>
              )}

              <div className="mb-6">
                <p className={`font-dm text-xs tracking-[0.3em] uppercase mb-2 ${plan.featured ? 'text-white/70' : 'text-sage'}`}>
                  {plan.name}
                </p>
                <div className="flex items-baseline gap-1">
                  <span className="font-playfair text-5xl font-light">€{plan.price}</span>
                  <span className={`font-dm text-sm ${plan.featured ? 'text-white/60' : 'text-ink-light'}`}>{plan.period}</span>
                </div>
                <p className={`font-dm text-sm mt-3 leading-relaxed ${plan.featured ? 'text-white/80' : 'text-ink-light'}`}>
                  {plan.desc}
                </p>
              </div>

              <div className="w-full h-px mb-6 opacity-20 bg-current" />

              <ul className="space-y-3 mb-8">
                {plan.features.map((f) => (
                  <li key={f} className="flex items-start gap-3">
                    <Check
                      size={14}
                      className={`mt-0.5 flex-shrink-0 ${plan.featured ? 'text-white' : 'text-sage'}`}
                      strokeWidth={2.5}
                    />
                    <span className={`font-dm text-sm ${plan.featured ? 'text-white/85' : 'text-ink'}`}>{f}</span>
                  </li>
                ))}
              </ul>

              <button
                className={`w-full py-3.5 rounded-full font-dm text-sm font-medium transition-all duration-300 cursor-pointer ${
                  plan.featured
                    ? 'bg-white text-sage hover:bg-cream'
                    : 'bg-sage text-white hover:bg-sage-dark'
                }`}
              >
                {plan.cta}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
